import {
  Box,
  CircularProgress,
  circularProgressClasses,
  Typography,
  CircularProgressProps,
  styled
} from '@mui/material';

export default function CircleProgressBar(props: CircularProgressProps) {
  const CircleProgressBackground = styled(CircularProgress)({
    color: '#919EAB'
  });
  const ProgressBody = styled(Box)({
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });
  return (
    <Box sx={{ position: 'relative' }}>
      <CircleProgressBackground variant="determinate" size={100} thickness={5} value={100} />
      <CircularProgress
        variant="determinate"
        sx={{
          color: '#00AB55',
          position: 'absolute',
          left: 0,
          animationDuration: '550ms',
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
          }
        }}
        size={100}
        thickness={5}
        value={props.value}
        {...props}
      />
      <ProgressBody>
        <Typography variant="caption">{`${props.value}%`}</Typography>
      </ProgressBody>
    </Box>
  );
}
